export class Snapshot {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultStorageTier",
            "baseName": "vaultStorageTier",
            "type": "VaultStorageTier",
            "format": ""
        },
        {
            "name": "isNative",
            "baseName": "isNative",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": ""
        },
        {
            "name": "expirationTime",
            "baseName": "expirationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "backupRetention",
            "baseName": "backupRetention",
            "type": "number",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SnapshotStatus",
            "format": ""
        },
        {
            "name": "resource",
            "baseName": "resource",
            "type": "ResourceSnapshot",
            "format": ""
        },
        {
            "name": "fullSizeBytes",
            "baseName": "fullSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "incrementalSizeBytes",
            "baseName": "incrementalSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "accessDeniedItemsCount",
            "baseName": "accessDeniedItemsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "accessDeniedItemsBytes",
            "baseName": "accessDeniedItemsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "skippedItemsCount",
            "baseName": "skippedItemsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "skippedItemsBytes",
            "baseName": "skippedItemsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "decompressiveTranscodedItemsCount",
            "baseName": "decompressiveTranscodedItemsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "decompressiveTranscodedItemsBytes",
            "baseName": "decompressiveTranscodedItemsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "deletedItemsCount",
            "baseName": "deletedItemsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "deletedItemsBytes",
            "baseName": "deletedItemsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "modifiedItemsCount",
            "baseName": "modifiedItemsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "modifiedItemsBytes",
            "baseName": "modifiedItemsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "userFilteredObjectsCount",
            "baseName": "userFilteredObjectsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "userFilteredObjectsBytes",
            "baseName": "userFilteredObjectsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "userDailyBudgetExceededItemsCount",
            "baseName": "userDailyBudgetExceededItemsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "userDailyBudgetExceededItemsBytes",
            "baseName": "userDailyBudgetExceededItemsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "securityScan",
            "baseName": "securityScan",
            "type": "SecurityScan",
            "format": ""
        },
        {
            "name": "securityScanConclusions",
            "baseName": "securityScanConclusions",
            "type": "Array<SecurityScanConclusion>",
            "format": ""
        },
        {
            "name": "isCdc",
            "baseName": "isCdc",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "supportPiTR",
            "baseName": "supportPiTR",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "withAttributesBackup",
            "baseName": "withAttributesBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "protectedFromDeletion",
            "baseName": "protectedFromDeletion",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "onHold",
            "baseName": "onHold",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "holdDescription",
            "baseName": "holdDescription",
            "type": "string",
            "format": ""
        },
        {
            "name": "fsxSnapshotProperties",
            "baseName": "fsxSnapshotProperties",
            "type": "FsxSnapshotProperties",
            "format": ""
        },
        {
            "name": "efsSnapshotProperties",
            "baseName": "efsSnapshotProperties",
            "type": "EfsSnapshotProperties",
            "format": ""
        },
        {
            "name": "documentDbSnapshotProperties",
            "baseName": "documentDbSnapshotProperties",
            "type": "DocumentDbSnapshotProperties",
            "format": ""
        },
        {
            "name": "neptuneSnapshotProperties",
            "baseName": "neptuneSnapshotProperties",
            "type": "NeptuneSnapshotProperties",
            "format": ""
        },
        {
            "name": "eksClusterSnapshotProperties",
            "baseName": "eksClusterSnapshotProperties",
            "type": "EksClusterSnapshotProperties",
            "format": ""
        },
        {
            "name": "googleWorkspaceSnapshotProperties",
            "baseName": "googleWorkspaceSnapshotProperties",
            "type": "GoogleWorkspaceSnapshotProperties",
            "format": ""
        },
        {
            "name": "isUnencryptedSource",
            "baseName": "isUnencryptedSource",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "recordRestoreEligible",
            "baseName": "recordRestoreEligible",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "securityFindingsSummary",
            "baseName": "securityFindingsSummary",
            "type": "Array<DetectorSummary>",
            "format": ""
        },
        {
            "name": "sameSourceRestoreOnly",
            "baseName": "sameSourceRestoreOnly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sourceProviderAccountId",
            "baseName": "sourceProviderAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Snapshot.attributeTypeMap;
    }
    constructor() {
    }
}
